document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".collapse-container").forEach(container => {
    const topContainer = container.querySelector(".top-container");
    const chevronTop = container.querySelector(".chevron.top");
    const chevronBottom = container.querySelector(".chevron.bottom");
    const bottomContainer = container.querySelector(".bottom-container");

    if (topContainer && chevronTop && chevronBottom && bottomContainer) {
      topContainer.addEventListener("click", () => {
        // Si le contenu est déjà visible
        if (bottomContainer.classList.contains("hidden")) {
          chevronTop.classList.remove("hidden"); // Affiche le signe +
          chevronBottom.classList.add("hidden"); // Cache le signe -
          bottomContainer.classList.remove("hidden"); // Affiche le contenu
        } else {
          chevronTop.classList.add("hidden"); // Cache le signe +
          chevronBottom.classList.remove("hidden"); // Affiche le signe -
          bottomContainer.classList.add("hidden"); // Cache le contenu
        }
      });
    }
  });
});

